import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useCurrentUser } from "../contexts/CurrentUserContext";

export const RedirectSupport = () => {
  const history = useHistory();
  const user = useCurrentUser();

  useEffect(() => {
    const handleMount = async () => {
      if (!user) {
        history.push("/needtosigninsupport");
      }
    };

    handleMount();
  }, [user, history]);
};

export default RedirectSupport;
